import PostboxesStatus from './postboxesStatus';

export default PostboxesStatus;
